import React from "react";
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import i18next from "i18next";
import { _checkValue, getImageUploadViewValue } from '../../helpers/form';
import { deepFind } from '../../helpers/deepFind';
import ReactHtmlParser from 'react-html-parser';
import dot from 'dot-object';
import { getSectionLabel, getSelectOptions, propHasValue } from "../DynamicFormNew/helper";
import { Descriptions, Tag, Switch, Tooltip, Image } from 'antd';
import 'moment/locale/fr';
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import AjaxModal from "./components/ajaxModal";
import { Link } from "react-router-dom";
import { maxBounds } from "../../constants/map";
import Geolocation from "../../screens/ViewTIF/components/geolocation";

export function numberWithCommas(x) {
  try {
    if (propHasValue(x)) {
      const parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return x;
  } catch (e) {
    console.log(e);
  }
}

export function getOutputLabel(input, formsValue = {}, asText = false) {
  const label = input.outputLabel || input.label;
  if (typeof label === 'object') {
    const validations = Object.keys(label);
    const key = validations.find(v => {
      let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
      const value = dot.pick(path, formsValue);
      return _checkValue(wantedValue, match, value)
    });
    const l = key ? label[key] : label[validations[0]];
    return input.description && !asText ? (
      <>
        {ReactHtmlParser(l)}
        <Tooltip title={input.description} placement="top">
          <InfoCircleOutlined className="ml-1" />
        </Tooltip>
      </>
    ) : ReactHtmlParser(l)
  } else {
    return input.description && !asText ? (
      <>
        {(ReactHtmlParser(label))}
        <Tooltip title={input.description} placement="top">
          <InfoCircleOutlined className="ml-1" />
        </Tooltip>
      </>
    ) : ReactHtmlParser(label)
  }
}
const checkCondition = (condition, formsValue, repeatValues, input) => {
  let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty )/gmi);
  match = match ? match.trim() : null;
  const isRepeatable = field.split('./').length > 1;
  const isNotEmpty = match === 'notEmpty';
  const formValue = isRepeatable ? repeatValues : formsValue;
  field = isRepeatable ? field.split('./')[1] : field;
  if (match && field.split('.').length > 1) {
    if (input.inputs) {
      const value = deepFind(formValue, field);
      const isShown = _checkValue(
        isNotEmpty ? field : wantedValue,
        match,
        isNotEmpty ? formValue : value
      );
      return isShown;
    } else {
      if ((isRepeatable ? !repeatValues : !formsValue)) {
        return false;
      } else {
        const value = deepFind(formValue, field);
        const isShown = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        return isShown;
      }
    }
  } else {
    const value = deepFind(formValue, field);
    const isShown = _checkValue(
      isNotEmpty ? field : wantedValue,
      match,
      isNotEmpty ? formValue : value
    );
    return isShown;
  }
}
export function showHideInput(input, formsValue, repeatValues) {
  if (input.showIf && !input.excludeFromView) {
    const isOrCond = input.showIf.indexOf('OR') >= 0;
    const allParts = input.showIf.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => checkCondition(condition, formsValue, repeatValues, input));
    return parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
  }
  if (typeof input.excludeFromView === 'string') {
    const isOrCond = input.excludeFromView.indexOf('OR') >= 0;
    const allParts = input.excludeFromView.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => checkCondition(condition, formsValue, repeatValues, input));
    const excludeFromView = parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
    return !excludeFromView
  }
  if (input.excludeFromView) {
    return false;
  }
  return true;
}
export function inputConstruct(name, input, value, commentValue = null, groupInputs, formsValue, repeatValues) {
  const dName = name.split(':');
  const obj = {
    ...input,
    name: name,
    originalName: dName.length === 2 ? dName[1] : dName[0],
    index: Number(dName.length === 2 ? dName[0] : '0'),
    isShown: true,
    label: input.outputLabel || input.label,
    rules: (input.rules || []).map(r => {
      if (r.message && r.message.indexOf('errors::') >= 0) {
        r.message = i18next.t(r.message);
      }
      return r;
    }),
    commentValue
  };
  if (input.showIf || input.excludeFromView) {
    Object.assign(obj, {
      showIf: input.showIf,
      isShown: showHideInput(input, formsValue, repeatValues),
    });
  }
  if (input.restricted) {
    Object.assign(obj, {
      restricted: input.restricted,
    });
  }
  if (input.comment) {
    Object.assign(obj, {
      showComment: false,
    });
  }
  if (propHasValue(value) && input.inputType !== 'group') {
    Object.assign(obj, {
      value: ['date', 'year'].includes(input.inputType)
        ? moment(value) : value,
    });
  }
  if (input.excludeFromView) {
    Object.assign(obj, {
      excludeFromView: input.excludeFromView,
    });
  }
  if (input.inputType === 'group') {
    const gInputs = {};
    Object.keys((groupInputs || {})).forEach(gIn => {
      const gInput = groupInputs[gIn];
      const inputId = gInput.dataId || gIn;
      const allValues = repeatValues ? repeatValues : formsValue;
      const gInpValue = ((allValues && propHasValue(allValues[inputId])) ? allValues[inputId] :
        (gInput.inputType === 'total100' ? [{
          type: null,
          value: null
        }] : (gInput.inputType === 'switch' ? false : null)));
      gInputs[gIn] = inputConstruct(
        inputId,
        gInput,
        gInpValue,
        gInput.comment && allValues && allValues[`${inputId}Comment`] ? allValues[`${inputId}Comment`] : null,
        gInput.inputType === 'group' ? gInput.groupInputs || {} : null,
        formsValue,
        repeatValues
      );
    })
    Object.assign(obj, {
      groupInputs: gInputs,
    });
  }
  return obj;
}

export const getInputConstruct = (inp, inputId, data, excludedKeys) => {
  if (inp.inputs) {
    const allInputs = Object.keys(inp.inputs).filter(input =>
      !excludedKeys.includes(input) &&
      (
        !['h2', 'h3', 'h4', 'h5', 'h6'].includes(inp.inputs[input].inputType) ||
        inp.inputs[input].display
      )
    );
    const obj = {
      ...inp,
      name: inputId,
      label: inp.outputLabel || inp.label, //getInputLabel(inp, data),
      sectionLabel: inp.sectionLabel ? getSectionLabel(inp.sectionLabel, data) : (inp.outputLabel || inp.label), //getInputLabel(inp, data)),
      repeatable: inp.repeatable,
      showOnView: inp.showOnView,
      repeats: 0,
      isShown: true,
      inputs: []
    };
    if (inp.repeatable) {
      const repeatValues = Array.isArray(data[inputId]) && data[inputId].length > 0 ? data[inputId] : [{}];
      const repeatInputs = repeatValues.map((groupValues, i) => {
        const o = {
          ...inp,
          name: inputId,
          label: `${getOutputLabel(inp, data)} (${i + 1})`,
          isShown: true,
          inputs: [],
          groupValues,
        };
        const groupInp = allInputs.map(input => {
          const grInput = inp.inputs[input];
          const grInputId = grInput.dataId || input;
          const value = ((groupValues && propHasValue(groupValues[grInputId])) ? groupValues[grInputId] :
            (grInput.inputType === 'total100' ? [{
              type: null,
              value: null
            }] : (grInput.inputType === 'switch' ? false : null)));
          const gObj = inputConstruct(
            grInputId,
            grInput,
            value,
            grInput.comment && groupValues && groupValues[`${grInputId}Comment`] ? groupValues[`${grInputId}Comment`] : null,
            grInput.inputType === 'group' ? grInput.groupInputs || {} : null,
            data,
            groupValues
          );
          gObj.parent = inputId;
          return gObj;
        });
        const removeInputs = [];
        const documentInput = groupInp.map(d => {
          if (d.display === 'document' && d.documentConfig) {
            d.document = {};
            if (d.name === d.documentConfig.status) {
              d.document.status = d;
            } else {
              d.document.status = groupInp.find(g => g.name === d.documentConfig.status);
              removeInputs.push(d.documentConfig.status);
            }
            d.document.link = groupInp.find(g => g.name === d.documentConfig.link);
            d.document.file = groupInp.find(g => g.name === d.documentConfig.file);
            removeInputs.push(d.documentConfig.link, d.documentConfig.file);
          }
          return d;
        });
        o.inputs = documentInput.filter(g => !removeInputs.includes(g.name));
        o.isShown = o.inputs.length && o.inputs.filter(g => g.isShown).length > 0 ? true : false;
        return o;
      });
      obj.inputs = repeatInputs;
      obj.isShown = repeatInputs.length && repeatInputs.filter(r => r.isShown).length > 0 ? true : false;
    } else {
      if (inp.refValues) {
        inputId = inp.refValues;
      }
      const groupValues = typeof data[inputId] === 'object' ? (
        Array.isArray(data[inputId]) ? (data[inputId].length > 0 ? data[inputId][0] : {}) : data[inputId]
      ) : {};
      const groupInp = allInputs.map(input => {
        const grInput = inp.inputs[input];
        const grInputId = grInput.dataId || input;
        const value = ((groupValues && propHasValue(groupValues[grInputId])) ? groupValues[grInputId] :
          (grInput.inputType === 'total100' ? [{
            type: null,
            value: null
          }] : (grInput.inputType === 'switch' ? false : null)));
        const gObj = inputConstruct(
          grInputId,
          grInput,
          value,
          grInput.comment && groupValues && groupValues[`${grInputId}Comment`] ? groupValues[`${grInputId}Comment`] : null,
          grInput.inputType === 'group' ? grInput.groupInputs || {} : null,
          data,
          groupValues
        );
        gObj.parent = inputId;
        return gObj;
      });
      const removeInputs = [];
      const documentInput = groupInp.map(d => {
        if (d.display === 'document' && d.documentConfig) {
          d.document = {};
          if (d.name === d.documentConfig.status) {
            d.document.status = d;
          } else {
            d.document.status = groupInp.find(g => g.name === d.documentConfig.status);
            removeInputs.push(d.documentConfig.status);
          }
          d.document.link = groupInp.find(g => g.name === d.documentConfig.link);
          d.document.file = groupInp.find(g => g.name === d.documentConfig.file);
          removeInputs.push(d.documentConfig.link, d.documentConfig.file);
        }
        return d;
      });
      obj.groupValues = groupValues;
      obj.inputs = documentInput.filter(g => !removeInputs.includes(g.name));;
      obj.isShown = obj.inputs.length && obj.inputs.filter(g => g.isShown).length > 0 ? true : false;
    }
    return obj;
  } else {
    const value = ((data && propHasValue(data[inputId])) ? data[inputId] :
      (inp.inputType === 'total100' ? [{
        type: null,
        value: null
      }] : (inp.inputType === 'switch' ? false : null)));
    const obj = inputConstruct(
      inputId,
      inp,
      value,
      inp.comment && data && data[`${inputId}Comment`] ? data[`${inputId}Comment`] : null,
      inp.inputType === 'group' ? inp.groupInputs || {} : null,
      data,
      undefined
    );
    obj.parent = inputId;
    return obj;
  }
}
export const getFormInputs = (inputs, formConf, data, excludedKeys) => {
  let removedInputs = [];
  inputs.forEach(input => {
    const inp = formConf[input];
    if (inp && inp.display === 'group') {
      const includeGroupInp = Object.keys(formConf).filter(k =>
        formConf[k] && formConf[k].viewGroup === input);
      removedInputs = [
        ...removedInputs,
        ...includeGroupInp,
      ];
      includeGroupInp.forEach(i => {
        dot.move(i, `${input}.group.${i}`, formConf)
      });
    }
  });

  const allInputs = inputs.filter(input =>
    !removedInputs.includes(input) && (!['h2', 'h3', 'h4', 'h5', 'h6']
      .includes(formConf[input].inputType) || formConf[input].display))
    .map(input => {
      const inp = formConf[input];
      const inputId = inp.dataId || input;
      if (inp.display) {
        if (inp.display === 'group' && inp.group && Object.keys(inp.group).length) {
          const groupInputs = Object.keys(inp.group).map(gi => {
            const gInp = inp.group[gi];
            const gInpId = gInp.dataId || gi;
            return getInputConstruct(gInp, gInpId, data, excludedKeys);
          });
          const removeInputs = [];
          const documentInput = groupInputs.map(d => {
            if (d.display === 'document' && d.documentConfig) {
              d.document = {};
              if (d.name === d.documentConfig.status) {
                d.document.status = d;
              } else {
                d.document.status = groupInputs.find(g => g.name === d.documentConfig.status);
                removeInputs.push(d.documentConfig.status);
              }
              d.document.link = groupInputs.find(g => g.name === d.documentConfig.link);
              d.document.file = groupInputs.find(g => g.name === d.documentConfig.file);
              removeInputs.push(d.documentConfig.link, d.documentConfig.file);
            }
            return d;
          });
          const gInputs = documentInput.filter(g => !removeInputs.includes(g.name));
          return {
            name: inputId,
            label: inp.outputLabel || inp.label,
            position: inp.position,
            display: inp.display,
            isShown: gInputs.length && gInputs.filter(g => g.isShown).length > 0 ? true : false,
            inputs: gInputs,
            inputType: inp.inputType,
            marginBottom: inp.marginBottom,
            groupHeader: inp.groupHeader,
            marginTop: inp.marginTop,
          }
        } else if (inp.display === 'sameData' && inp.conditions) {
          const conditions = Object.keys(inp.conditions);
          if (conditions.length) {
            const key = conditions.find(v => {
              let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
              const value = dot.pick(path, data);
              return _checkValue(wantedValue, match, value)
            });
            const replaceInp = inp.conditions[key];
            if (replaceInp && Object.keys(replaceInp).length > 0) {
              const refValues = inp.refValues[key];
              inp.refValues = refValues;
              inp.inputs = {};
              Object.keys(replaceInp).forEach(c => {
                const ic = dot.pick(replaceInp[c], formConf);
                if (typeof ic === 'object') {
                  inp.inputs[c] = ic;
                }
              });
            } else {
              inp.refValues = undefined;
            }
          }
        }
      }
      return getInputConstruct(inp, inputId, data, excludedKeys);
    });

  const removeInputs = [];
  const documentInput = allInputs.map(d => {
    if (d.display === 'document' && d.documentConfig) {
      d.document = {};
      if (d.name === d.documentConfig.status) {
        d.document.status = d;
      } else {
        d.document.status = allInputs.find(g => g.name === d.documentConfig.status);
        removeInputs.push(d.documentConfig.status);
      }
      d.document.link = allInputs.find(g => g.name === d.documentConfig.link);
      d.document.file = allInputs.find(g => g.name === d.documentConfig.file);
      removeInputs.push(d.documentConfig.link, d.documentConfig.file);
    }
    return d;
  });
  return documentInput.filter(g => !removeInputs.includes(g.name));
}

export function getOption(options, value) {
  if (typeof options === 'string') {
    return value;
  }
  const option = options.find(opt => opt.value === value);
  return option ? option : { label: value };
}
export const getDocument = (input, currentForm, documentConfig, fieldInd, dataOptions, isGroup, data, actions) => {
  if (input.name === documentConfig.status) {
    if (input.document) {
      const status = input.document.status;
      if (status && status.value) {
        const option = getOption(status.options, status.value);
        let link = '';
        if (['linked', 'upload'].includes(status.value)) {
          if (status.value === 'linked') {
            const fileInput = input.document.link;
            if (fileInput && fileInput.value) {
              link = <a href={fileInput.value} target="_blank" rel="noreferrer">{fileInput.value}</a>
            }
          }
          if (status.value === 'upload') {
            const fileInput = input.document.file
            link = getInputContent(fileInput, currentForm, fieldInd, dataOptions, isGroup, data, actions);
          }
          return <div className="ant-descriptions p-0 ant-descriptions-small ant-descriptions-bordered">
            <div className="ant-descriptions-view">
              <table>
                <tbody>
                  <tr className="ant-descriptions-row">
                    <td className="ant-descriptions-item-content" colSpan="1">{option.label}</td>
                    <td className="ant-descriptions-item-content" colSpan="2">{link}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        }
        return option.label;
      }
    }
  }
  return '';
}
const imageUpload = (value = []) => {
  let fileList = getImageUploadViewValue(value);

  return fileList.length ? <div className="image-container">
    {fileList.filter(f => f.url).map(v => (
      <Image
        width={200}
        src={v.url}
      />
    ))}
  </div> : null;
};
export function getInputContent(input, currentForm, fieldInd, dataOptions, isGroup = false, data = {}, actions = {}) {
  const lng = localStorage.getItem('datastakeLng') || 'en';
  if (input) {
    if (input.display === 'document' && input.documentConfig) {
      return getDocument(input, currentForm, input.documentConfig, fieldInd, dataOptions, isGroup, data, actions);
    } else if (input.inputType === 'number') {
      return propHasValue(input.value) ? numberWithCommas(input.value) : '';
    } else if (input.inputType === 'select') {
      return getOptionLabel(input.options, input.value, input.defaultValue, data);
    } else if (input.inputType === 'multiselect') {
      return (input.value ? (Array.isArray(input.value) ? input.value : [input.value]) : []).map((value, i) => {
        const option = getOption(input.options, value)
        return <Tag key={i} color={option.color || input.color || 'default'} >{option.label}</Tag>
      }
      );
    } else if (input.inputType === 'checkboxGroup') {
      return (input.value ? (Array.isArray(input.value) ? input.value : [input.value]) : []).map((value, i) => {
        const option = getOption(input.options, value)
        return <Tag key={i} color={option.color || input.color || 'default'} >{option.label}</Tag>
      }
      );
    } else if (input.inputType === 'date') {
      return input.value ? moment(input.value).locale(lng === 'fr' ? 'fr' : 'en').format('DD MMM YYYY') : '';
    } else if (input.inputType === 'total100') {
      const total = (input.value).reduce((a, b) => a + (Number(b.value) || 0), 0);
      return input.value && input.value.length > 0 ? <div className="ant-descriptions p-0 ant-descriptions-small ant-descriptions-bordered">
        <div className="ant-descriptions-view">
          <table>
            <tbody>
              {input.value.map((value, i) => (
                <tr key={i} className="ant-descriptions-row">
                  <td className="ant-descriptions-item-content" colSpan="1">{getOptionLabel(input.options, value.type, undefined, data)}</td>
                  <td className="ant-descriptions-item-content" colSpan="2">{value.value}%</td>
                </tr>
              ))}
              <tr className="ant-descriptions-row">
                <td className="ant-descriptions-item-content" colSpan="1"><span className="title-semibold-5" style={{ color: 'black' }}> {i18next.t('Total')}</span></td>
                <td className="ant-descriptions-item-content" colSpan="2"><span className="title-semibold-5" style={{ color: total === 100 ? 'green' : 'red' }}> {total}%</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> : ''
    } else if (input.inputType === 'switch') {
      if (input.displayValue) {
        if (input.value) {
          return input.displayValue.true[lng] || input.displayValue.true.en;
        }
        return input.displayValue.false[lng] || input.displayValue.false.en;
      }
      return <Switch disabled checked={input.value || false}></Switch>
    } else if (input.inputType === 'percentage') {
      return input.value ? `${input.value}%` : '';
    } else if (input.inputType === 'year') {
      return `${input.value ? moment(input.value).locale(lng === 'fr' ? 'fr' : 'en').format('YYYY') : ''}`;
    } else if (input.inputType === 'geolocation') {
      if (input.value && input.value.latitude && input.value.longitude) {
        const id = Date.now();
        setTimeout(() => {
          try {
            var container = L.DomUtil.get(document.getElementById(id));
            if (container != null) {
              container._leaflet_id = null;
            }
            const map = new L.map(document.getElementById(id), {
              maxZoom: 18,
              preferCanvas: true,
              zoomControl: true,
              doubleClickZoom: false,
              dragging: true,
              scrollWheelZoom: false,
              maxBounds: maxBounds,
            });
            if (input.value && input.value.latitude && input.value.longitude) {
              const zoom = map.getZoom() ? map.getZoom() : 11;
              map.setView([input.value.latitude, input.value.longitude], zoom);
            } else {
              map.locate({ setView: true, watch: true, maxZoom: 18 });
              map.on('locationfound', (ev) => {
                const zoom = map.getZoom() ? map.getZoom() : 11;
                map.setView([ev.latlng.lat, ev.latlng.lng], zoom);
              })
              map.on('locationerror', (ev) => {
                const zoom = map.getZoom() ? map.getZoom() : 11;
                map.setView([1.5743, 30.2397], zoom);
              })
            }
            L.control.scale().addTo(map)
            L.tileLayer(
              'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            ).addTo(map);
            L.marker([input.value.latitude, input.value.longitude], {
              icon: new L.Icon({
                iconUrl: "/assets/images/map/position.png",
                iconSize: [20, 30]
              })
            }).addTo(map)
          } catch (e) { }
        }, 1000)
        return <div
          id={id}
          style={{
            width: '100%',
            height: '200px'
          }}>
        </div>
      }
      return <div>{i18next.t('No GPS data')}</div>
    } else if (input.inputType === 'ajaxSelect') {
      if (Array.isArray(input.value)) {
        return input.value.map((v, ind) => {
          const exists = dataOptions.find(opt => opt.value === v);
          const label = exists ? exists.label ? exists.label : exists.value : v;
          return <Tag key={`${input.name}-${ind}`}>{label}</Tag>
        })
      }
      const exists = dataOptions.find(opt => opt.value === input.value);
      const label = exists ? (exists.label ? exists.label : exists.value) : input.value;
      return input.value ? <Tag key={input.name}>{label}</Tag> : null;
    } else if (input.inputType === 'upload') {
      const accept = input.rules.length ? (input.rules.find(rule => Object.keys(rule).includes('accept')).accept || '*') : null;
      return <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {input.value && Array.isArray(input.value) && input.value.map((upload, i) => (
          (accept && accept === 'image/*')
            ? <a key={i} href={upload.url}>
              <img style={{ maxWidth: '300px' }} alt="img" src={upload.url} />
            </a>
            : <a key={i} href={upload.url}><Tag>{upload.name}</Tag></a>
        ))}
      </div>
    } else if (input.inputType === 'imageUpload') {
      return imageUpload(input.value);
    } else if (input.inputType === 'tag') {
      return (input.value ? (Array.isArray(input.value) ? input.value : [input.value]) : []).map((value, i) => {
        return <Tag key={i} color={input.color || 'default'} >{value}</Tag>
      }
      );
    } else if (input.inputType === 'modal') {
      let repeatValues = {};
      if (currentForm && Array.isArray(currentForm) && currentForm.length) {
        const formName = currentForm[0].name;
        if (typeof fieldInd === 'number' && Array.isArray(data[formName]) && data[formName][fieldInd]) {
          repeatValues = data[formName][fieldInd];
        }
      }
      return <AjaxModal
        isGroup={isGroup}
        value={input.value}
        parent={input.parent}
        call={input.call}
        formsValue={data}
        repeatValues={repeatValues}
        removeFromView={input.removeFromView}
      />;
    } else if (input.inputType === 'group') {
      const gInputs = Object.keys(input.groupInputs);
      const totalGInputs = gInputs.length;
      if (input.display === 'table') {
        return <Descriptions
          className={"p-0"}
          bordered
          size="small"
          layout="vertical"
          column={totalGInputs}>
          {gInputs.map((i, k) => {
            const inp = input.groupInputs[i];
            if (!propHasValue(inp.value)) {
              inp.value = '-'
            }
            return <Descriptions.Item
              key={k}
              label={inp.outputLabel || inp.label}>
              {getInputContent(inp, currentForm, undefined, [], false, data, actions)}
            </Descriptions.Item>
          })}
        </Descriptions>
      } else if (input.display === 'plain') {
        return gInputs.map((i, ind) => {
          const len = totalGInputs;
          const inp = input.groupInputs[i];
          if (!propHasValue(inp.value)) {
            inp.value = '-'
          }
          return `${len === 3 && ind === (len - 1) ? '/ ' : ''}${getInputContent(inp, currentForm, undefined, [], false, data, actions)}`;
        }).join(' ');
      }
      return gInputs.map(i => {
        const inp = input.groupInputs[i];
        if (!propHasValue(inp.value)) {
          inp.value = '-'
        }
        return <span key={i} ><Tag>{inp.outputLabel || inp.label}: {getInputContent(inp, currentForm, undefined, [], false, data, actions)}</Tag></span>;
      });
    } else if (input.inputType === 'internallink') {
      return input.value ? <Link to={input.value}>{i18next.t('View')}</Link> : '';
    }
    return propHasValue(input.value) ? input.value.toString() : '';
  } else {
    return '';
  }
}

export function getInputContentNew(input, currentForm, fieldInd, dataOptions = [], isGroup = false, data = {}, actions = {}) {
  const lng = localStorage.getItem('datastakeLng') || 'en';
  if (input) {
    if (input.display === 'document' && input.documentConfig) {
      return getDocument(input, currentForm, input.documentConfig, fieldInd, dataOptions, isGroup, data, actions);
    } else if (input.type === 'number') {
      return propHasValue(input.value) ? numberWithCommas(input.value) : '';
    } else if (input.type === 'select') {
      return getOptionLabel(input.options, input.value, input.defaultValue, data);
    } else if (input.type === 'multiselect') {
      return (input.value ? (Array.isArray(input.value) ? input.value : [input.value]) : []).map((value, i) => {
        const option = getOption(input.options, value)
        return <Tag key={i} color={option.color || input.color || 'default'} >{option.label}</Tag>
      }
      );
    } else if (input.type === 'checkboxGroup') {
      return (input.value ? (Array.isArray(input.value) ? input.value : [input.value]) : []).map((value, i) => {
        const option = getOption(input.options, value)
        return <Tag key={i} color={option.color || input.color || 'default'} >{option.label}</Tag>
      }
      );
    } else if (input.type === 'date') {
      return input.value ? moment(input.value).locale(lng === 'fr' ? 'fr' : 'en').format('DD MMM YYYY') : '';
    } else if (input.type === 'total100') {
      const total = (input.value).reduce((a, b) => a + (Number(b.value) || 0), 0);
      return input.value && input.value.length > 0 ? <div className="ant-descriptions p-0 ant-descriptions-small ant-descriptions-bordered">
        <div className="ant-descriptions-view">
          <table>
            <tbody>
              {input.value.map((value, i) => (
                <tr key={i} className="ant-descriptions-row">
                  <td className="ant-descriptions-item-content" colSpan="1">{getOptionLabel(input.options, value.type, undefined, data)}</td>
                  <td className="ant-descriptions-item-content" colSpan="2">{value.value}%</td>
                </tr>
              ))}
              <tr className="ant-descriptions-row">
                <td className="ant-descriptions-item-content" colSpan="1"><span className="title-semibold-5" style={{ color: 'black' }}> {i18next.t('Total')}</span></td>
                <td className="ant-descriptions-item-content" colSpan="2"><span className="title-semibold-5" style={{ color: total === 100 ? 'green' : 'red' }}> {total}%</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> : ''
    } else if (input.type === 'switch') {
      if (input.displayValue) {
        if (input.value) {
          return input.displayValue.true[lng] || input.displayValue.true.en;
        }
        return input.displayValue.false[lng] || input.displayValue.false.en;
      }
      return <Switch disabled checked={input.value || false}></Switch>
    } else if (input.type === 'percentage') {
      return input.value ? `${input.value}%` : '';
    } else if (input.type === 'year') {
      return `${input.value ? moment(input.value).locale(lng === 'fr' ? 'fr' : 'en').format('YYYY') : ''}`;
    } else if (input.type === 'geolocation') {
      if (input.value && input.value.latitude && input.value.longitude) {
        return <Geolocation val={input.value} showViewOnMap={false} />
      }
      return <div>{i18next.t('No GPS data')}</div>
    } else if (input.type === 'ajaxSelect') {
      if (Array.isArray(input.value)) {
        return input.value.map((v, ind) => {
          const exists = dataOptions.find(opt => opt.value === v);
          const label = exists ? exists.label ? exists.label : exists.value : v;
          return <Tag key={`${input.name}-${ind}`}>{label}</Tag>
        })
      }
      const exists = dataOptions.find(opt => opt.value === input.value);
      const label = exists ? (exists.label ? exists.label : exists.value) : input.value;
      return input.value ? label : null;
    } else if (input.type === 'upload') {
      const accept = input.rules.length ? (input.rules.find(rule => Object.keys(rule).includes('accept')).accept || '*') : null;
      return <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {input.value && Array.isArray(input.value) && input.value.map((upload, i) => (
          (accept && accept === 'image/*')
            ? <a key={i} href={upload.url}>
              <img style={{ maxWidth: '300px' }} alt="img" src={upload.url} />
            </a>
            : <a key={i} href={upload.url}><Tag>{upload.name}</Tag></a>
        ))}
      </div>
    } else if (input.type === 'imageUpload') {
      return imageUpload(input.value);
    } else if (input.type === 'tag') {
      return (input.value ? (Array.isArray(input.value) ? input.value : [input.value]) : []).map((value, i) => {
        return <Tag key={i} color={input.color || 'default'} >{value}</Tag>
      }
      );
    } else if (input.type === 'modal') {
      let repeatValues = {};
      if (currentForm && Array.isArray(currentForm) && currentForm.length) {
        const formName = currentForm[0].name;
        if (typeof fieldInd === 'number' && Array.isArray(data[formName]) && data[formName][fieldInd]) {
          repeatValues = data[formName][fieldInd];
        }
      }
      return <AjaxModal
        isGroup={isGroup}
        value={input.value}
        parent={input.parent}
        call={input.call}
        formsValue={data}
        repeatValues={repeatValues}
        removeFromView={input.removeFromView}
      />;
    } else if (input.type === 'group') {
      const gInputs = Object.keys(input.groupInputs);
      const totalGInputs = gInputs.length;
      if (input.display === 'table') {
        return <Descriptions
          className={"p-0"}
          bordered
          size="small"
          layout="vertical"
          column={totalGInputs}>
          {gInputs.map((i, k) => {
            const inp = input.groupInputs[i];
            if (!propHasValue(inp.value)) {
              inp.value = '-'
            }
            return <Descriptions.Item
              key={k}
              label={inp.outputLabel || inp.label}>
              {getInputContent(inp, currentForm, undefined, [], false, data, actions)}
            </Descriptions.Item>
          })}
        </Descriptions>
      } else if (input.display === 'plain') {
        return gInputs.map((i, ind) => {
          const len = totalGInputs;
          const inp = input.groupInputs[i];
          if (!propHasValue(inp.value)) {
            inp.value = '-'
          }
          return `${len === 3 && ind === (len - 1) ? '/ ' : ''}${getInputContent(inp, currentForm, undefined, [], false, data, actions)}`;
        }).join(' ');
      }
      return gInputs.map(i => {
        const inp = input.groupInputs[i];
        if (!propHasValue(inp.value)) {
          inp.value = '-'
        }
        return <span key={i} ><Tag>{inp.outputLabel || inp.label}: {getInputContent(inp, currentForm, undefined, [], false, data, actions)}</Tag></span>;
      });
    } else if (input.type === 'internallink') {
      return input.value ? <Link to={input.value}>{i18next.t('View')}</Link> : '';
    }
    return propHasValue(input.value) ? input.value.toString() : '';
  } else {
    return '';
  }
}


export function getOptionLabel(options, value, defaultValue, formsValue) {
  if (typeof options === 'string') {
    return value;
  }
  let option = (options || []).find(opt => opt.value === value);
  if (!option && defaultValue) {
    option = (options || []).find(opt => opt.value === defaultValue);
  }
  if (option) {
    option = getSelectOptions(option, formsValue)
  }
  return (option && option.label ? option.label : value) || '--';
}
export function getOptionConfig(options, value) {
  if (typeof options === 'string') {
    return value;
  }
  const option = (options || []).find(opt => opt.value === value);
  return option || {};
}
export const getValueFromConfig = (input, currentForm, name, fieldInd) => {
  if (input.documentConfigFromInputs) {
    const confInput = (currentForm || []).find(c => c && c.name === input.documentConfigFromInputs);
    if (confInput) {
      if (
        propHasValue(fieldInd) &&
        confInput.inputs &&
        confInput.inputs[fieldInd]
      ) {
        return dot.pick(name, confInput.inputs[fieldInd]);
      }
      return dot.pick(name, confInput);
    }
  } else if (input.inputs) {
    return dot.pick(name, input);
  } else {
    const confInput = (currentForm || []).find(c => c && c.name === name);
    if (
      propHasValue(fieldInd) &&
      confInput.inputs &&
      confInput.inputs[fieldInd]
    ) {
      return confInput.inputs[fieldInd];
    }
    return confInput;
  }
}
